<template>
  <div class="procesos-container">
    <!-- Unified Container -->
    <div class="unified-container">
      <!-- Header Section -->
      <div class="header-section">
        <div class="title-section">
          <v-icon class="title-icon" color="white">mdi-file-document</v-icon>
          <div class="title-text">
            <h1 class="main-title">PROCESOS ACEPTADOS</h1>
            <p class="subtitle">Gestión de procesos de compra</p>
          </div>
        </div>
      </div>

      <!-- Search Section -->
      <div class="search-section">
        <div class="search-card">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar Proceso"
            solo
            flat
            hide-details
            class="search-field"
          ></v-text-field>
        </div>
      </div>
      <!-- Dialog observaciones -->
      <v-dialog
        v-model="dialog"
        persistent
        :overlay="true"
        width="90%"
        overlay-color="black"
        overlay-opacity="0.8"
      >
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: white"
              ><v-icon color="white">mdi-clipboard-edit-outline</v-icon>
              Proceso
            </span>
          </v-card-title>
          <!-- componente del modal para agregar y actualizar -->

          <div style="width: 95%; margin: 3rem 0rem 0rem 2rem">
            <v-layout wrap>
              <v-flex
                xs9
                sm9
                md9
                style="border-top: 1px solid black; border-left: 1px solid"
              >
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border: solid 1px black; border-right: 0px"
                class="displayCenter fondo"
              >
                <span><strong>Proveedor 1</strong></span>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border: solid 1px black; border-right: 0px"
                class="displayCenter fondo"
              >
                <span><strong>Proveedor 2</strong></span>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border: solid 1px black"
                class="displayCenter fondo"
              >
                <span><strong>Proveedor 3</strong></span>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex
                xs2
                sm2
                md2
                style="border: solid 1px black; border-right: 0px"
                class="displayCenter fondo"
              >
                <strong>DESCRIPCION</strong>
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                style="border: solid 1px black"
                class="displayCenter fondo"
              >
                <strong>DETALLE TÉCNICO</strong>
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                style="border: solid 1px black; border-right: 0px"
                class="displayCenter fondo"
              >
                <strong>ARGUMENTO PARA LA COMPRA</strong>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border: solid 1px black"
                class="displayCenter fondo"
              >
                <strong>CANT</strong>
              </v-flex>
              <v-layout wrap>
                <v-flex
                  xs4
                  sm4
                  md4
                  style="border: solid 1px black"
                  class="displayCenter fondo"
                >
                  <span style="font-size: 14px"
                    ><strong>VALOR UNITARIO</strong></span
                  >
                </v-flex>
                <v-flex
                  xs4
                  sm4
                  md4
                  style="border: solid 1px black"
                  class="displayCenter fondo"
                >
                  <span style="font-size: 14px"
                    ><strong>VALOR UNITARIO</strong></span
                  >
                </v-flex>
                <v-flex
                  xs4
                  sm4
                  md4
                  style="border: solid 1px black"
                  class="displayCenter fondo"
                >
                  <span style="font-size: 14px"
                    ><strong>VALOR UNITARIO</strong></span
                  >
                </v-flex>
              </v-layout>
            </v-layout>
            <v-layout
              wrap
              v-for="(item, index) in editedItem.infoProceso"
              :key="index"
              style="border: solid 1px black; border-top: 0px"
            >
              <v-flex
                xs2
                sm2
                md2
                style="border-right: solid 1px black"
                class="displayCenter"
              >
                {{ item.concepto }}
              </v-flex>
              <v-flex xs3 sm3 md3 style="border-right: solid 1px black">
                {{ item.expecificaciones }}
              </v-flex>
              <v-flex xs3 sm3 md3 style="border-right: solid 1px black">
                {{ item.observaciones }}
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border-right: solid 1px black"
                class="displayCenter"
              >
                {{ item.cantidad }}
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border-right: solid 1px black"
                class="displayEnd"
              >
                {{
                  editedItem.proveedor1.valores[index].valorUnitario | currency
                }}
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border-right: solid 1px black"
                class="displayEnd"
              >
                {{
                  editedItem.proveedor2.valores[index].valorUnitario | currency
                }}
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border-right: solid 1px black"
                class="displayEnd"
              >
                {{
                  editedItem.proveedor3.valores[index].valorUnitario | currency
                }}
              </v-flex>
            </v-layout>

            <v-layout
              wrap
              class="d-flex"
              style="border: solid 1px black; border-top: 0px"
            >
              <v-flex> </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-bottom: 0px;
                "
              >
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-if="dialog === true"
                    style="border-bottom: solid 1px black"
                  >
                    <label for=""
                      ><strong>SUBTOTAL</strong><br />{{
                        editedItem.proveedor1.subTotal | currency
                      }}</label
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-bottom: 0px;
                "
              >
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-if="dialog === true"
                    style="border-bottom: solid 1px black"
                  >
                    <label for=""
                      ><strong>SUBTOTAL</strong><br />{{
                        editedItem.proveedor2.subTotal | currency
                      }}</label
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-bottom: 0px;
                  border-right: 0px;
                "
              >
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-if="dialog === true"
                    style="border-bottom: solid 1px black"
                  >
                    <label for=""
                      ><strong>SUBTOTAL</strong><br />{{
                        editedItem.proveedor3.subTotal | currency
                      }}</label
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex
                xs6
                sm6
                md6
                v-if="dialog === true"
                style="border: solid 1px black; border-top: 0px"
                class="displayCenter fondo"
              >
                <label for=""><strong>NOMBRE EMPRESA</strong></label>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialog === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <label for="">{{ editedItem.proveedor1.nombreEmpresa }}</label>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialog === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <label for="">{{ editedItem.proveedor2.nombreEmpresa }}</label>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialog === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <label for="">{{ editedItem.proveedor3.nombreEmpresa }}</label>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex
                xs6
                sm6
                md6
                v-if="dialog === true"
                style="border: solid 1px black; border-top: 0px"
                class="displayCenter fondo"
              >
                <label for=""> <strong>ARGUMENTO PARA LA COMPRA</strong></label>
              </v-flex>
              <v-flex
                xs6
                sm6
                md6
                v-if="dialog === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <label for="">{{ editedItem.observacion }}</label>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex
                xs6
                sm6
                md6
                v-if="dialog === true"
                style="border: solid 1px black; border-top: 0px"
                class="displayCenter fondo"
              >
                <label for=""> <strong>ARCHIVO ADJUNTO</strong></label>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialog === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <v-btn
                  v-if="editedItem.ruta_img1"
                  @click="viewImage(editedItem.ruta_img1)"
                  outlined
                  color="primary"
                >
                  Ver Imagen
                </v-btn>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialog === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <v-btn
                  v-if="editedItem.ruta_img2"
                  @click="viewImage(editedItem.ruta_img2)"
                  valores
                  color="primary"
                >
                  Ver Imagen
                </v-btn>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialog === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <v-btn
                  v-if="editedItem.ruta_img3"
                  @click="viewImage(editedItem.ruta_img3)"
                  outlined
                  color="primary"
                >
                  Ver Imagen
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout wrap class="mt-5">
              <v-flex xs3 sm3 md3>
                <v-text-field
                  disabled
                  label="Maira Londoño"
                  class="mr-4"
                ></v-text-field>
                <label for="">ELABORADO POR</label>
                <br />
                Creado:
                <label for="">{{ editedItem.fechaProveedores }}</label>
              </v-flex>
              <v-flex xs6 class="d-flex">
                <v-layout
                  wrap
                  v-for="(item, index) in editedItem.aprobacion"
                  :key="index"
                >
                  <v-flex xs12 sm12 md12 v-if="item.rol === 'DIRECTOR AREA'">
                    <v-text-field
                      :value="item.firma"
                      disabled
                      class="mr-4"
                    ></v-text-field>
                    <label for="">APROBACION DIRECTOR DE ÁREA</label>
                    <br />
                    Aprobado:
                    <label for="">{{ item.fechaAprobacion }}</label>
                  </v-flex>
                  <v-flex xs12 sm12 md12 v-if="item.rol === 'CONTROL INTERNO'">
                    <v-text-field disabled :value="item.firma"></v-text-field>
                    <label for="">REVISIÓN DIRECCION FINANCIERA</label>
                    <br />
                    Aprobado:
                    <label for="">{{ item.fechaAprobacion }}</label>
                  </v-flex>
                  <v-flex xs12 sm12 md12 v-if="item.rol === 'GERENTE'">
                    <v-text-field disabled :value="item.firma"></v-text-field>
                    <label for="">APROBACIÓN DE LA GERENCIA</label>
                    <br />
                    Aprobado:
                    <label for="">{{ item.fechaAprobacion }}</label>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>

          <!-- botones para cancelar y agregregar y validacion de campos vacios -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn elevation="2" color="#f7e506" @click="close">cerrar</v-btn>
            <!-- <v-btn elevation="2"  color="red" @click="contenidoPdf"
                            > IMPRIMIR</v-btn
                        > -->
          </v-card-actions>
          <!-- <pre>{{editedItem}}</pre>  -->
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogRechazar"
        persistent
        :overlay="true"
        width="60%"
        overlay-color="black"
        overlay-opacity="0.8"
      >
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: white"
              ><v-icon color="white">mdi-application-cog</v-icon>Rechazar
              Proceso</span
            >
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-textarea
                    v-model="observaciones"
                    label="Argumento para la compra"
                    maxlength="80"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <!-- botones para cancelar y agregregar y validacion de campos vacios -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#f7e506" @click="close1">Cancelar</v-btn>
            <v-btn color="#f7e506" @click="rechazarProceso()">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Table Section -->
      <div class="table-section">
        <div class="table-card">
          <v-data-table
            :headers="headers"
            :items="procesos"
            :search="search"
            class="modern-table"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [10, 20, 50],
              'items-per-page-text': 'Filas por página:',
            }"
          >
            <template v-slot:no-data>
              <v-alert
                :value="true"
                color="#F44336"
                icon="mdi-alert"
                outlined
                type="warning"
                prominent
                border="left"
              >
                <strong>No</strong> se encontro su busqueda
              </v-alert>
            </template>
            <!--acciones de los datos obtenidos del arreglo-->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="action-icons">
                <div v-if="item.aprobacion === null" class="action-group">
                  <v-icon
                    class="action-icon approve-icon"
                    @click="aceptar(item)"
                    title="Aceptar"
                  >
                    mdi-check-bold
                  </v-icon>
                  <v-icon
                    class="action-icon reject-icon"
                    @click="rechazar(item)"
                    title="Rechazar"
                  >
                    mdi-close-thick
                  </v-icon>
                </div>
              </div>
            </template>

            <template v-slot:[`item.pdfGeneral`]="{ item }">
              <v-icon class="pdf-icon" @click="modalPdf(item)" title="Ver PDF">
                mdi-file-pdf-box
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </div>

      <!-- Snackbar para notificaciones -->
      <v-snackbar
        v-model="snackbar"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
        color="#3b82f6"
        class="modern-snackbar"
      >
        {{ text }}
        <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
import Vue from "vue";
import html2canvas from "html2canvas";
import VueCurrencyFilter from "vue-currency-filter";
Vue.use(VueCurrencyFilter, {
  symbol: "$",
  thousandsSeparator: ".",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: true,
});

export default {
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      procesos: [],
      infoProcesos: [],
      valoresProveedores: [],
      dialog: false,
      dialogRechazar: false,
      observaciones: "",
      selectedItem: null,
      headers: [
        {
          text: "ID proceso",
          value: "idProceso",
          align: "center",
          class: "column",
        },
        {
          text: "Area",
          value: "nombreArea",
          align: "center",
          class: "column",
        },
        {
          text: "Empresa",
          value: "empresa",
          align: "center",
          class: "column",
        },
        {
          text: "Director",
          value: "nombre",
          align: "center",
          class: "column",
        },
        {
          text: "General",
          value: "pdfGeneral",
          align: "center",
          class: "column",
        },
        {
          text: "Fecha compra",
          value: "fechaProveedores",
          align: "center",
          class: "column",
        },
        {
          text: "Acciones",
          value: "actions",
          align: "center",
          class: "column",
        },
      ],
      defaultItem: {
        id: "",
        concepto: "",
        cantidad: "",
        especificacion: "",
        observaciones: "",
        aprobacion: "",
      },
      editedIndex: -1,
      editedItem: {
        observacion: "",
      },
      deleteItem: {},
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.obtenerApps();
  },
  methods: {
    viewImage(rutaImg) {
      window.open(rutaImg, "_blank");
    },
    obtenerApps() {
      axios
        .get(
          `${
            env.endpoint
          }user/procesosDirectorAreaProveedores?idUser=${localStorage.getItem(
            "id"
          )}`
        )
        .then((res) => {
          this.procesos = res.data;

          // Process each proceso to add empresa field
          this.procesos = this.procesos.map((proceso) => {
            if (proceso.infoProceso && proceso.infoProceso.length > 0) {
              proceso.empresa = proceso.infoProceso
                .map((element) => element.empresa)
                .join(", ");
            }
            return proceso;
          });

          // If you need to add idProceso to each infoProceso item, do it correctly
          this.procesos.forEach((proceso) => {
            if (proceso.infoProceso && proceso.infoProceso.length > 0) {
              proceso.infoProceso.forEach((info) => {
                info.idProceso = proceso.idProceso;
              });
            }
          });
        })
        .catch((error) => {
          console.error("Error fetching processes:", error);
          this.text =
            "Ha ocurrido un error al cargar los procesos. Si el problema persiste comuníquese con el área de sistemas";
          this.snackbar = true;
        });
    },
    rechazoItem(item) {
      this.editedIndex = this.procesos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog_observaciones = true;
    },
    editItem(item) {
      this.editedIndex = this.procesos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    close1() {
      this.dialogRechazar = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    aceptar(item) {
      swal({
        title: "Aceptar proceso",
        text: "Proceso aceptado satisfactoriamente",
        icon: "success",
        buttons: ["Cancelar", true],
      }).then((willDelete) => {
        if (willDelete) {
          // Mostrar overlay de carga
          this.showGlobalOverlay("Procesando aprobación...");

          const aceptar = new FormData();
          aceptar.append("idUser", localStorage.getItem("id"));
          aceptar.append("firma", localStorage.getItem("firma"));
          aceptar.append("rol", "DIRECTOR AREA");
          aceptar.append("idProceso", item.idProceso);
          aceptar.append("estado", 5);
          axios
            .post(`${env.endpoint}user/enviarAprobacion`, aceptar, {})
            .then((res) => {
              // Actualizar mensaje del overlay
              this.showGlobalOverlay("Actualizando datos...");

              swal("Se ha enviado con exito!", {
                icon: "success",
              });
              // Refrescar datos sin recargar la página para evitar que el loader quede visible
              this.obtenerApps();
              this.close();
            })
            .catch((error) => {
              console.error("Error approving process:", error);
              this.text =
                "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
              this.snackbar = true;
            })
            .finally(() => {
              // Cerrar overlay global
              this.hideGlobalOverlay();
              this.close();
              this.obtenerApps();
            });
        } else {
          swal("Proceso de eviado sea cancelado");
        }
      });
    },
    rechazar(item) {
      this.editedIndex = this.procesos.indexOf(item);
      this.deleteItem = Object.assign({}, item);
      this.dialogRechazar = true;
      this.selectedItem = item;
    },
    rechazarProceso() {
      const aceptar = new FormData();
      aceptar.append("idUser", localStorage.getItem("id"));
      aceptar.append("observacion", this.observaciones);
      aceptar.append("idProceso", this.selectedItem.idProceso);
      swal({
        title: "Este proceso sera cancelado.",
        text: "Una vez cancelado no se podra recuperar.",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          // Mostrar overlay de carga
          this.showGlobalOverlay("Procesando rechazo...");

          axios
            .post(`${env.endpoint}user/denegarAprobacion`, aceptar, {})
            .then((res) => {
              // Actualizar mensaje del overlay
              this.showGlobalOverlay("Actualizando datos...");

              this.dialogRechazar = false;
              this.obtenerApps();
              swal("Se ha enviado con exito!", {
                icon: "success",
              });
            })
            .catch((error) => {
              this.obtenerApps();
              this.text =
                "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
            })
            .finally(() => {
              // Cerrar overlay global
              this.hideGlobalOverlay();
              this.dialogRechazar = false;
              this.editarinventario = res.data;
              this.obtenerApps();
            });
        } else {
          swal("Proceso de eviado sea cancelado");
          this.close1();
        }
      });
      this.obtenerApps();
    },
    modalPdf(item) {
      this.editedIndex = this.procesos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.menosValor(this.editedItem);
      this.dialog = true;
    },
    menosValor(item) {
      let valoresProveedor1 = item.proveedor1.valores;
      let valoresProveedor2 = item.proveedor2.valores;
      let valoresProveedor3 = item.proveedor3.valores;
      for (let index = 0; index < item.proveedor3.valores.length; index++) {
        let valoresFor = [];
        let proveedor1 = Number(valoresProveedor1[index].valorTotal);
        let proveedor2 = Number(valoresProveedor2[index].valorTotal);
        let proveedor3 = Number(valoresProveedor3[index].valorTotal);
        if (proveedor1 <= proveedor2 && proveedor1 <= proveedor3) {
          valoresFor.push(proveedor1);
          valoresFor.push("proveedor1");
        } else if (proveedor2 <= proveedor1 && proveedor2 <= proveedor3) {
          valoresFor.push(proveedor2);
          valoresFor.push("proveedor2");
        } else {
          valoresFor.push(proveedor3);
          valoresFor.push("proveedor3");
        }
        this.valoresProveedores.push(valoresFor);
      }
    },

    // Overlay global montado en body
    showGlobalOverlay(mensaje) {
      this.hideGlobalOverlay();
      const overlay = document.createElement("div");
      overlay.id = "global-loading-overlay";
      overlay.style.position = "fixed";
      overlay.style.top = "0";
      overlay.style.left = "0";
      overlay.style.width = "100%";
      overlay.style.height = "100%";
      overlay.style.background = "rgba(0,0,0,0.6)";
      overlay.style.zIndex = "9999";
      overlay.style.display = "flex";
      overlay.style.alignItems = "center";
      overlay.style.justifyContent = "center";
      overlay.style.backdropFilter = "blur(2px)";

      const card = document.createElement("div");
      card.style.background =
        "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)";
      card.style.borderRadius = "12px";
      card.style.padding = "32px 40px";
      card.style.minWidth = "320px";
      card.style.maxWidth = "90%";
      card.style.boxShadow =
        "0 20px 60px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.1)";
      card.style.display = "flex";
      card.style.flexDirection = "column";
      card.style.alignItems = "center";
      card.style.textAlign = "center";
      card.style.border = "1px solid rgba(255,255,255,0.2)";
      card.style.position = "relative";
      card.style.overflow = "hidden";

      // Efecto de brillo animado
      const shine = document.createElement("div");
      shine.style.position = "absolute";
      shine.style.top = "0";
      shine.style.left = "-100%";
      shine.style.width = "100%";
      shine.style.height = "100%";
      shine.style.background =
        "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)";
      shine.style.animation = "shine 2s ease-in-out infinite";
      card.appendChild(shine);

      // Contenedor del spinner
      const spinnerContainer = document.createElement("div");
      spinnerContainer.style.position = "relative";
      spinnerContainer.style.marginBottom = "20px";

      // Spinner principal
      const spinner = document.createElement("div");
      spinner.style.border = "4px solid rgba(25,118,210,0.1)";
      spinner.style.borderTop = "4px solid #1976d2";
      spinner.style.borderRadius = "50%";
      spinner.style.width = "60px";
      spinner.style.height = "60px";
      spinner.style.animation = "spin 1s linear infinite";
      spinner.style.position = "relative";
      spinner.style.zIndex = "2";

      // Spinner secundario (más pequeño)
      const spinner2 = document.createElement("div");
      spinner2.style.border = "3px solid rgba(76,175,80,0.1)";
      spinner2.style.borderTop = "3px solid #4caf50";
      spinner2.style.borderRadius = "50%";
      spinner2.style.width = "40px";
      spinner2.style.height = "40px";
      spinner2.style.animation = "spin 1.5s linear infinite reverse";
      spinner2.style.position = "absolute";
      spinner2.style.top = "10px";
      spinner2.style.left = "10px";
      spinner2.style.zIndex = "1";

      spinnerContainer.appendChild(spinner);
      spinnerContainer.appendChild(spinner2);

      // Texto principal
      const text = document.createElement("div");
      text.style.fontSize = "16px";
      text.style.fontWeight = "600";
      text.style.color = "#424242";
      text.style.marginBottom = "8px";
      text.style.letterSpacing = "0.2px";
      text.style.fontFamily =
        "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
      text.textContent = mensaje || "Procesando...";

      // Texto secundario
      const subText = document.createElement("div");
      subText.style.fontSize = "13px";
      subText.style.fontWeight = "400";
      subText.style.color = "#757575";
      subText.style.opacity = "0.9";
      subText.style.fontFamily =
        "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
      subText.textContent = "Por favor espere un momento";

      card.appendChild(spinnerContainer);
      card.appendChild(text);
      card.appendChild(subText);
      overlay.appendChild(card);
      document.body.appendChild(overlay);

      // Agregar estilos de animación si no existen
      if (!document.getElementById("loading-animations")) {
        const style = document.createElement("style");
        style.id = "loading-animations";
        style.textContent = `
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes shine {
            0% { left: -100%; }
            100% { left: 100%; }
          }
        `;
        document.head.appendChild(style);
      }
    },

    hideGlobalOverlay() {
      const overlay = document.getElementById("global-loading-overlay");
      if (overlay && overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    },
  },
};
</script>

<style scoped>
/* ===== DISEÑO MODERNO Y ELEGANTE ===== */
.procesos-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 3rem;
}

.unified-container {
  max-width: 1600px;
  margin: 0 auto;
  background: white;
  border-radius: 0;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* ===== HEADER SECTION ===== */
.header-section {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  padding: 2.5rem;
  color: white;
  position: relative;
  overflow: hidden;
}

.header-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 50%,
    rgba(255, 255, 255, 0.05) 100%
  );
  pointer-events: none;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  position: relative;
  z-index: 2;
}

.title-icon {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.title-text {
  flex: 1;
}

.main-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
}

.subtitle {
  font-size: 1rem;
  margin: 0;
  opacity: 0.9;
  font-weight: 400;
}

/* ===== SEARCH SECTION ===== */
.search-section {
  padding: 2.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: center;
}

.search-card {
  max-width: 500px;
  width: 100%;
}

.search-field {
  background: white !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
}

/* ===== TABLE SECTION ===== */
.table-section {
  padding: 0;
  background: white;
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
}

.table-card {
  padding: 0;
  background: white;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: visible;
}

/* ===== DISEÑO MINIMALISTA ELEGANTE PARA TABLA ===== */
.modern-table {
  background: white !important;
  border-radius: 0 !important;
  overflow: visible !important;
  box-shadow: none !important;
  border: none !important;
  min-width: 800px; /* Ancho mínimo para forzar scroll si es necesario */
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
  overflow-x: auto !important;
  overflow-y: visible !important;
  background: white !important;
}

/* Estilos para el scrollbar horizontal siempre visible */
.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  height: 12px !important; /* Más alto para mejor visibilidad */
  display: block !important;
  -webkit-appearance: none;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #e5e7eb !important; /* Más visible */
  border-radius: 6px !important;
  margin: 0 10px;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #64748b !important; /* Más oscuro para mejor visibilidad */
  border-radius: 6px !important;
  border: 2px solid #e5e7eb;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #475569 !important; /* Aún más oscuro al hover */
}

/* Para Firefox */
.modern-table >>> .v-data-table__wrapper {
  scrollbar-width: thin;
  scrollbar-color: #64748b #e5e7eb;
}

.modern-table >>> .v-data-table-header {
  background: white !important;
  border-bottom: 1px solid #e5e7eb !important;
  position: relative !important;
}

.modern-table >>> .v-data-table-header th {
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 0.9rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.8px !important;
  padding: 1.25rem 1rem !important;
  background: transparent !important;
  border-bottom: 2px solid #f3f4f6 !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr {
  transition: all 0.2s ease !important;
  border-bottom: 1px solid #f9fafb !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:nth-child(even) {
  background: #fafbfc !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:hover {
  background: #f8fafc !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr td {
  color: #1f2937 !important;
  font-weight: 400 !important;
  border-bottom: 1px solid #f3f4f6 !important;
  padding: 1.25rem 1rem !important;
  font-size: 0.9rem !important;
  line-height: 1.6 !important;
  vertical-align: middle !important;
}

/* ===== ICONOS DE ACCIONES MODERNOS ===== */
.action-icons {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  justify-content: center;
}

.action-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.action-icon {
  font-size: 20px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  padding: 4px !important;
  border-radius: 4px !important;
}

.approve-icon {
  color: #059669 !important;
}

.approve-icon:hover {
  color: #047857 !important;
  transform: scale(1.1) !important;
}

.reject-icon {
  color: #dc2626 !important;
}

.reject-icon:hover {
  color: #b91c1c !important;
  transform: scale(1.1) !important;
}

.pdf-icon {
  color: #dc2626 !important;
  font-size: 20px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  padding: 4px !important;
}

.pdf-icon:hover {
  color: #b91c1c !important;
  transform: scale(1.1) !important;
}

/* ===== FOOTER DE TABLA ===== */
.modern-table >>> .v-data-footer {
  background: white !important;
  border-top: 1px solid #e5e7eb !important;
  padding: 1.25rem !important;
  border-radius: 0 !important;
}

.modern-table >>> .v-data-footer__select {
  color: #6b7280 !important;
  font-weight: 500 !important;
  font-size: 0.9rem !important;
}

.modern-table >>> .v-data-footer__pagination {
  color: #6b7280 !important;
  font-weight: 500 !important;
  font-size: 0.9rem !important;
}

.modern-table >>> .v-data-footer .v-btn {
  background: #f3f4f6 !important;
  color: #374151 !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 6px !important;
  transition: all 0.2s ease !important;
  font-size: 0.9rem !important;
  padding: 0.6rem 0.9rem !important;
  font-weight: 500 !important;
}

.modern-table >>> .v-data-footer .v-btn:hover {
  background: #e5e7eb !important;
  border-color: #d1d5db !important;
  transform: translateY(-1px) !important;
}

/* ===== SNACKBAR MODERNO ===== */
.modern-snackbar {
  border-radius: 8px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
}

/* ===== ESTILOS PARA MODAL ===== */
.fondo {
  background-color: #f3f4f6;
}

.displayCenter {
  display: flex;
  justify-content: center;
  align-items: center;
  word-break: break-all;
  padding: 8px;
  font-size: 0.85rem;
  font-weight: 500;
}

.displayEnd {
  display: flex;
  justify-content: end;
  align-items: end;
  word-break: break-all;
  padding: 8px;
  font-size: 0.85rem;
}

.colorMin {
  background-color: #dbeafe;
}

/* ===== RESPONSIVE DESIGN ===== */
@media (max-width: 768px) {
  .procesos-container {
    padding: 1rem;
  }

  .unified-container {
    margin: 0;
    border-radius: 0;
  }

  .header-section {
    padding: 1.5rem;
  }

  .title-section {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .main-title {
    font-size: 1.5rem;
  }

  .search-section {
    padding: 1.5rem;
  }
}
</style>
